export default __webpack_public_path__ + "static/media/Sand.5d0686fa.svg";